import { Separator } from '@/components/ui/separator.tsx'
import { AutoFollowForm } from '@/modules/automations/ui/forms/auto-follow-form'
import { AutoUnFollowForm } from '@/modules/automations/ui/forms/auto-unfollow-form.tsx'
import { SettingsSkeleton } from '@/modules/automations/ui/skeleton'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider'

export const AutoFollowView = () => {
  const {
    autoFollowExpiredFans,
    autoUnfollowEnabled,
    autoUnfollowMaximumSpend,
    autoFollowMinimumSpend,
    autoUnfollowAfterFollowingDays,
    isFetching,
  } = useSettingsContext()

  if (isFetching) {
    return <SettingsSkeleton />
  }

  return (
    <>
      <AutoFollowForm
        data={{ autoFollowExpiredFans, autoFollowMinimumSpend }}
      />
      <Separator className="my-8" />
      <AutoUnFollowForm
        data={{
          autoUnfollowEnabled: autoUnfollowEnabled,
          autoUnfollowMaximumSpend: autoUnfollowMaximumSpend,
          autoUnfollowAfterFollowingDays: autoUnfollowAfterFollowingDays,
        }}
      />
    </>
  )
}
